import { effects } from 'redux-saga'

export default function* downloadPdf({ invocation }, action) {
  const signup = action.payload.signup
  const url = `${invocation.endpoint}/signup/${signup.get('id')}.pdf?accessKey=${signup.get('accessKey')}`

  yield effects.call(() => { window.location.href = url })
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/downloadPdf.js